import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack, last } from '../../utils/index.js';
var round = Math.round;
var rgb2hex = function rgb2hex() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'rgba'),
    _unpack2 = _slicedToArray(_unpack, 4),
    r = _unpack2[0],
    g = _unpack2[1],
    b = _unpack2[2],
    a = _unpack2[3];
  var mode = last(args) || 'auto';
  if (a === undefined) a = 1;
  if (mode === 'auto') {
    mode = a < 1 ? 'rgba' : 'rgb';
  }
  r = round(r);
  g = round(g);
  b = round(b);
  var u = r << 16 | g << 8 | b;
  var str = '000000' + u.toString(16); //#.toUpperCase();
  str = str.substr(str.length - 6);
  var hxa = '0' + round(a * 255).toString(16);
  hxa = hxa.substr(hxa.length - 2);
  switch (mode.toLowerCase()) {
    case 'rgba':
      return "#".concat(str).concat(hxa);
    case 'argb':
      return "#".concat(hxa).concat(str);
    default:
      return "#".concat(str);
  }
};
export default rgb2hex;